
import { createSlice } from "@reduxjs/toolkit";

export const initValueClient = {
    codigo: '',
    nombre: 'Nombre del cliente',
    ciudad: '',
    direccion: '',
    id_cliente: '',
    canalVenta: '',
    idCliente: ''
}

export const selectClientSlice = createSlice({
    name: 'selectClientStore',
    initialState: {
        value: initValueClient
    },
    reducers: {
        setSelectClient: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { setSelectClient } = selectClientSlice.actions

export default selectClientSlice.reducer